import type { ISerialize } from '@/objects/ISerialize';

export class ImportDuplicateContestant implements ISerialize {
    public BuypassID: string | null;

    public CategoryName: string | null;

    public Firstname: string | null;

    public NifID: string | null;

    public RaceName: string | null;

    public Surname: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        BuypassID?: string | null;
        CategoryName?: string | null;
        Firstname?: string | null;
        NifID?: string | null;
        RaceName?: string | null;
        Surname?: string | null;
    }) {
        this.BuypassID = values.BuypassID ?? '';

        this.CategoryName = values.CategoryName ?? '';

        this.Firstname = values.Firstname ?? '';

        this.NifID = values.NifID ?? '';

        this.RaceName = values.RaceName ?? '';

        this.Surname = values.Surname ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"BuypassID": ${JSON.stringify(this.BuypassID)}` +
            ',' +
            `"CategoryName": ${JSON.stringify(this.CategoryName)}` +
            ',' +
            `"Firstname": ${JSON.stringify(this.Firstname)}` +
            ',' +
            `"NifID": ${JSON.stringify(this.NifID)}` +
            ',' +
            `"RaceName": ${JSON.stringify(this.RaceName)}` +
            ',' +
            `"Surname": ${JSON.stringify(this.Surname)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ImportDuplicateContestant from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        BuypassID?: string | null;
        CategoryName?: string | null;
        Firstname?: string | null;
        NifID?: string | null;
        RaceName?: string | null;
        Surname?: string | null;
    }): ImportDuplicateContestant {
        return new ImportDuplicateContestant(values);
    }

    public static _FromServerJson(json: any): ImportDuplicateContestant {
        return new ImportDuplicateContestant({
            BuypassID: json.BuypassID ?? '',
            CategoryName: json.CategoryName ?? '',
            Firstname: json.Firstname ?? '',
            NifID: json.NifID ?? '',
            RaceName: json.RaceName ?? '',
            Surname: json.Surname ?? '',
        });
    }

    /**
     * Creates an instance of ImportDuplicateContestant from another instance of ImportDuplicateContestant.
     * @param other The ImportDuplicateContestant you want to clone
     * @returns A cloned ImportDuplicateContestant
     */
    public static FromOther(other: ImportDuplicateContestant): ImportDuplicateContestant {
        return ImportDuplicateContestant._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ImportDuplicateContestant.FromOther(this);
    }

    static NAME_OF_CLASS = 'ImportDuplicateContestant';
}
